import React, { FunctionComponent } from "react";
import BodyText from "../typography/BodyText";
import { TitleHeading } from "../typography/TitleHeading";
import Section from "../layout/Section";

type SideImageTextSectionProps = {
  tag: string;
  title: JSX.Element | string;
  text?: string | React.ReactNode;
  image: string;
  theme?: "dark" | "white" | "gray";
  imagePosition?: string;
  inverse?: boolean;
  bgIcon?: boolean;
};

const SideImageTextSection: FunctionComponent<SideImageTextSectionProps> = ({
  tag,
  title,
  text,
  children,
  image,
  theme,
  imagePosition = "object-center",
  inverse,
  bgIcon,
}) => {
  return (
    <div className="relative z-10">
      <Section theme={theme} className="z-20">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-16 container md:px-5 xl:px-12 mx-auto">
          <div className="flex justify-center items-center">
            <img
              src={image}
              className={`h-96 rounded-3xl z-20 object-cover ${imagePosition} shadow-lg ${inverse ? "order-2" : ""} bg-gray-100 dark:bg-gray-800`}
            />
          </div>
          <div className="flex flex-col justify-center">
            <div>
              <TitleHeading tag={tag} title={title} theme={theme} />
              <BodyText
                dark={theme === "dark"}
                className="text-justify mt-6"
                mb="6"
              >
                {text}
              </BodyText>
              {children}
            </div>
          </div>
        </div>
      </Section>
      {bgIcon &&
        typeof image !== "string" &&
        React.cloneElement(image, {
          className:
            "z-10 h-full text-gray-50 opacity-20 absolute -right-[10%] top-0",
        })}
    </div>
  );
};

export default SideImageTextSection;
